<mat-table *ngIf="!isCustomizedTable" [dataSource]="dataSource.filteredData" style="display: grid; overflow-x: auto" (matSortChange)="onSort($event)" matSort [ngClass]="themeClass">
  <ng-container matColumnDef="select" *ngIf="checkbox">
    <mat-header-cell *matHeaderCellDef style="max-width: 50px; padding-left: 10px">
      <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()"
        class="success-checkbox">
      </mat-checkbox>
    </mat-header-cell>

    <mat-cell *matCellDef="let row" style="max-width: 50px; padding-left: 10px">
      <mat-checkbox (click)="$event.stopPropagation();" (change)="$event ? selection.toggle(row) : null"
        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel()" class="success-checkbox" [disabled]="row.isDisable">
      </mat-checkbox>
    </mat-cell>
  </ng-container>

  <ng-container *ngFor="let column of dynamicColumns" [matColumnDef]="column?.columnDef">
    <ng-container *ngIf="column?.sortable">
      <mat-header-cell *matHeaderCellDef style="font-size: 16px" [ngClass]="commonService.getCellWidthClass(column.columnDef)" mat-sort-header>
        {{ column?.header }}
      </mat-header-cell>
    </ng-container>
    <ng-container *ngIf="!column?.sortable">
      <mat-header-cell *matHeaderCellDef style="font-size: 16px" [ngClass]="commonService.getCellWidthClass(column.columnDef)">
        {{ column?.header }}
      </mat-header-cell>
    </ng-container>
    <mat-cell *matCellDef="let row; let i = index;" [ngClass]="commonService.getCellWidthClass(column.columnDef)">
      <ng-container [ngSwitch]="column?.type">
        <span *ngSwitchCase="'status'" class="py-2 px-2" [ngClass]="
            column.cell(row) == 'Active' || column.cell(row) == 'Future'
              ? 'active-status'
              : 'inactive-status'
          ">
          {{ column.cell(row) }}
        </span>
        <!-- ++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
        <span *ngSwitchCase="'teamStatus'" class="py-2 px-2" [ngClass]="{
            'status-eligible': column.cell(row) == 'Eligible',
            'status-suspended': column.cell(row) == 'Suspended'
          }">
          {{ column.cell(row) }}
        </span>
        <!-- ++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
        <span *ngSwitchCase="'actions'">
          <div class="action-button-tab">
            <button *ngIf="column?.buttons.includes('view')" mat-icon-button class="view-btn"
              (click)="dispatchAction(row, 'view')" [disabled]="checkbox && !selection.isSelected(row)">
              <mat-icon>remove_red_eye</mat-icon>
            </button>
            <button *ngIf="column?.buttons.includes('edit')" mat-icon-button class="edit-btn"
              (click)="dispatchAction(row, 'edit')" [disabled]="checkbox && !selection.isSelected(row)">
              <span><mat-icon>edit</mat-icon></span>
            </button>
            <button *ngIf="column?.buttons.includes('delete')" mat-icon-button class="delete-btn"
              (click)="dispatchAction(row, 'delete')" color="warn" [disabled]="checkbox && !selection.isSelected(row)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </span>
        <!-- ++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
        <span *ngSwitchCase="'showType'">
          <p>
            {{ column.cell(row) | showType }}
          </p>
        </span>
        <!-- ++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
        <span *ngSwitchCase="'redirect'">
          <p class="redirect-link" (click)="dispatchAction(row, 'redirect')">
            {{ column.cell(row) }}
          </p>
        </span>
        <!-- ++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
        <span *ngSwitchCase="'UTCDate'">
          <p>{{ column.cell(row) | date: 'MM/dd/yyyy':'UTC' }}</p>
        </span>
        <!-- ++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
        <span *ngSwitchCase="'innerHtml'" [innerHtml]="column.cell(row)">

        </span>
        <!-- ++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
        <span *ngSwitchCase="'buttons'">
          <ng-container *ngIf="column.cell(row) == 'null'; else simpleText">
            <button mat-button color="primary" class="btn add-btn region-btn py-md-2 px-2 py-4"
              (click)="dispatchAction(row, column?.columnDef)">
              {{ column?.buttonText ? column?.buttonText : column?.columnDef }}
            </button>
          </ng-container>
          <ng-template #simpleText>
            <span class="ps-1 region-btn-new">{{ column.cell(row) }}</span>
          </ng-template>
        </span>
        <!-- Default type | Normal cell view -->
        <span *ngSwitchDefault>
          {{ column.cell(row, i) }}
        </span>
      </ng-container>
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="[row?.rowClass || 'default']"></mat-row>
</mat-table>

<section class="example-container table-responsive alternate-table-row mb-5" *ngIf="isCustomizedTable" [ngClass]="themeClass">
  <mat-table [dataSource]="dataSource.filteredData" (matSortChange)="onSort($event)" matSort cdkDropList 
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)">
    <ng-container matColumnDef="select" *ngIf="checkbox">
      <mat-header-cell *matHeaderCellDef cdkDrag>
        <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()"
          class="success-checkbox"></mat-checkbox>
      </mat-header-cell>
  
      <mat-cell *matCellDef="let row" cdkDrag>
        <mat-checkbox (click)="$event.stopPropagation();" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel()" class="success-checkbox"
          [disabled]="row.isDisable"></mat-checkbox>
      </mat-cell>
    </ng-container>
  
    <ng-container *ngFor="let column of dynamicColumns" [matColumnDef]="column?.columnDef">
      <ng-container *ngIf="column?.sortable">
        <mat-header-cell *matHeaderCellDef [style.width.px]="getColumnWidth(column.columnDef)"
        [style.minWidth.px]="getColumnWidth(column.columnDef)" [style.maxWidth.px]="getColumnWidth(column.columnDef)"
        mat-sort-header style="position: relative; padding-right: 12px; font-size: 16px;"
        cdkDrag>
        <span class="header-content">{{ column?.header }}</span>
  
        <div class="resizer" (mousedown)="startResize($event, column.columnDef); $event.stopPropagation();"
          (click)="$event.stopPropagation(); $event.preventDefault()"></div>
      </mat-header-cell>
      </ng-container>
      <ng-container *ngIf="!column?.sortable">
        <mat-header-cell *matHeaderCellDef [style.width.px]="getColumnWidth(column.columnDef)"
        [style.minWidth.px]="getColumnWidth(column.columnDef)" [style.maxWidth.px]="getColumnWidth(column.columnDef)"
        style="position: relative; padding-right: 12px; font-size: 16px;"
        cdkDrag>
        <span class="header-content">{{ column?.header }}</span>
  
        <div class="resizer mt-3" (mousedown)="startResize($event, column.columnDef); $event.stopPropagation();"
          (click)="$event.stopPropagation(); $event.preventDefault()"></div>
      </mat-header-cell>
      </ng-container>
  
      <mat-cell *matCellDef="let row; let i = index;" [style.width.px]="getColumnWidth(column.columnDef)"
        [style.minWidth.px]="getColumnWidth(column.columnDef)" [style.maxWidth.px]="getColumnWidth(column.columnDef)">
        <ng-container [ngSwitch]="column?.type">
          <span *ngSwitchCase="'status'" class="py-2 px-2" [ngClass]="
              column.cell(row) == 'Active' || column.cell(row) == 'Future'
                ? 'active-status'
                : 'inactive-status'
            ">
            {{ column.cell(row) }}
          </span>
  
          <span *ngSwitchCase="'teamStatus'" class="py-2 px-2" [ngClass]="{
            'status-eligible': column.cell(row) == 'Eligible',
            'status-suspended': column.cell(row) == 'Suspended'
          }">
            {{ column.cell(row) }}
          </span>
  
          <span *ngSwitchCase="'actions'">
            <div class="action-button-tab">
              <button *ngIf="column?.buttons.includes('view')" mat-icon-button class="view-btn"
                (click)="dispatchAction(row, 'view')" [disabled]="checkbox && !selection.isSelected(row)">
                <mat-icon>remove_red_eye</mat-icon>
              </button>
              <button *ngIf="column?.buttons.includes('edit')" mat-icon-button class="edit-btn"
                (click)="dispatchAction(row, 'edit')" [disabled]="checkbox && !selection.isSelected(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button *ngIf="column?.buttons.includes('delete')" mat-icon-button class="delete-btn"
                (click)="dispatchAction(row, 'delete')" color="warn" [disabled]="checkbox && !selection.isSelected(row)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </span>
  
          <span *ngSwitchCase="'showType'">
            <p>{{ column.cell(row) | showType }}</p>
          </span>
  
          <span *ngSwitchCase="'redirect'">
            <p class="redirect-link" (click)="dispatchAction(row, 'redirect')">
              {{ column.cell(row) }}
            </p>
          </span>
  
          <span *ngSwitchCase="'UTCDate'">
            <p>{{ column.cell(row) | date: 'MM/dd/yyyy':'UTC' }}</p>
          </span>
  
          <span *ngSwitchCase="'innerHtml'" [innerHTML]="column.cell(row)"></span>
  
          <span *ngSwitchCase="'buttons'">
            <ng-container *ngIf="column.cell(row) == 'null'; else simpleText">
              <button mat-button color="primary" class="btn add-btn region-btn py-md-2 px-2 py-4"
                (click)="dispatchAction(row, column?.columnDef)">
                {{ column?.buttonText ? column?.buttonText : column?.columnDef }}
              </button>
            </ng-container>
            <ng-template #simpleText>
              <span class="ps-1 region-btn-new">{{ column.cell(row) }}</span>
            </ng-template>
          </span>
  
          <span *ngSwitchDefault>
            {{ column.cell(row, i) }}
          </span>
        </ng-container>
      </mat-cell>
    </ng-container>
  
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="[row?.rowClass || 'default']"></mat-row>
  </mat-table>
</section>

<mat-paginator *ngIf="pagination" [length]="totalItemCount" [pageSize]="pageSize"
  [pageSizeOptions]="[10, 20, 25, 100, 500]" [pageIndex]="pageIndex" (page)="handlePagChange($event)"
  aria-label="Select page"></mat-paginator>





<!-- old code before refactor -->
<!-- <ng-container *ngIf="column.columnDef !== 'action'; else actionCell">
  <ng-container *ngIf="
            column.columnDef !== 'status' && column.columnDef !== 'isActive';
            else statusCell
          ">
    <ng-container *ngIf="column.columnDef !== 'region'; else regionCell">
      {{ column.cell(row) }}
    </ng-container>

    <ng-template #regionCell>
      <ng-container *ngIf="column.cell(row) == 'N.A.'; else regions">
        <button mat-button color="primary" class="btn add-btn region-btn py-md-2 px-2 py-4" (click)="regionAssign(row)">
          Assign Region
        </button>
      </ng-container>

      <ng-template #regions>
        <span class="ps-4 region-btn-new">{{ column.cell(row) }}</span>
      </ng-template>
      <span [innerHTML]=""></span>
    </ng-template>
  </ng-container>

  <ng-template #statusCell>
    <ng-container *ngIf="
              !['Pending', 'Eligible', 'Suspended'].includes(column.cell(row));
              else teamStatusCell
            ">
      <span class="py-2 px-2" [ngClass]="
                column.cell(row) == 'Active' || column.cell(row) == 'Future'
                  ? 'active-status'
                  : 'inactive-status'
              ">{{ column.cell(row) }}</span>
    </ng-container>

    <ng-template #teamStatusCell>
      <ng-container *ngIf="
                ['Pending', 'Eligible', 'Suspended'].includes(column.cell(row))
              ">
        <span class="py-2 px-2" [ngClass]="{
                  'status-eligible': column.cell(row) == 'Eligible',
                  'status-suspended': column.cell(row) == 'Suspended'
                }">{{ column.cell(row) }}</span>
      </ng-container>
    </ng-template>
  </ng-template>
</ng-container>

<ng-template #actionCell>
  <div class="row" style="margin-left: -25px">
    <div class="col-md-4" [class]="
              checkbox && !selection.isSelected(row)
                ? 'inactive-action-btn'
                : ''
            ">
      <button mat-mini-fabz matTooltip="view" [disabled]="checkbox && !selection.isSelected(row)"
        (click)="getDetails(row, 'view')" class="view-action-btn">
        <mat-icon>visibility</mat-icon>
      </button>
    </div>

    <div class="col-md-4" [class]="
              checkbox && !selection.isSelected(row)
                ? 'inactive-action-btn'
                : ''
            ">
      <button mat-mini-fabz matTooltip="edit" [disabled]="checkbox && !selection.isSelected(row)"
        (click)="getDetails(row, 'edit')" class="edit-action-btn">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>
</ng-template> -->
